export default {
  hosts: HOSTS,
};



// WEBPACK FOOTER //
// ./src/shared/settings.js